import { Field } from 'formik'
import type { ReactElement } from 'react'
import { useId } from 'react'

type Props = {
  options: { label: string; value: string }[]
  name: string
  disabled?: boolean
}

export default function RadioButtonGroup({ name, options, disabled = false }: Readonly<Props>): ReactElement {
  const id = useId()

  return (
    <div>
      {options.map((option) => (
        <span key={option.value}>
          <Field
            id={`${id}.${name}.${option.value}`}
            type="radio"
            name={name}
            value={option.value}
            disabled={disabled}
          />
          <label htmlFor={`${id}.${name}.${option.value}`}>{option.label}</label>
        </span>
      ))}
    </div>
  )
}
